<template>
    <div class="layer_pop_wrap">
        <div class='layer_pop_dim' :style="openBln ? 'display: flex; position: relative;' : 'display: none'">
            <div class="layer_pop lg editor dictionaryPopup" :class="openBln? 'active' : ''"
                 data-role-popup="modal_02"
                 tabindex="0"
                 :style="{ left: `${positionX}%`, top: `${positionY}%` }"
                 @mousedown="startDragging"
                 @mousemove="dragElement"
                 @mouseup="stopDragging"
                 @mouseleave="stopDragging">
                <div class="pop_head">
                    <h2>{{`${categoryToKoreaLang[category]}`}} 사전 조회 및 수정</h2>
                    <button type="button" class="pop_close" @click="clickCloseHandler">닫기</button>
                </div>
                <div class="pop_cont dictionaryPopup" @mousedown="preventDrag" style="padding-bottom:10px;">
                    <div class="layout_container dictionaryPopup">
                        <div class="layout_item" style="width: 50%" v-if="!changeOnlyDisplayWord">
                            <div class="search_form_wrap">
                                <ul class="search_form_list">
                                    <li :style="searchList.length == 0 && !loading ? 'width: 90%;' : 'width: 100%;'">
                                        <div class="inpt_sch">
                                            <input 
                                                    type="text" 
                                                    class="form_control" 
                                                    placeholder="검색어를 입력하세요."
                                                    :value="query"
                                                    @input="changeQuery"
                                                    @keydown="inputEnter">
                                            <button type="button" @click="search"></button>
                                        </div>
                                    </li>
                                    <li>
                                        <button class="sm_btn color_1" @click="createDictionary">신규등록</button>
                                    </li>
                                    <li>
                                        <button class="sm_btn color_1" @click="appendSimilarTag">유사어등록</button>
                                    </li>
                                </ul>
                            </div>
                            <!-- //search_form_wrap -->
                            <table class="tbl_style2">
                                <colgroup>
                                    <col style="width: 35%;">
                                    <col style="width: 35%;">
                                    <col style="width: 30%;">
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>
                                        유사어
                                        <button></button>
                                    </th>
                                    <th>
                                        대표어
                                    </th>
                                    <th>
                                        수정/유사어추가
                                        <button></button>
                                    </th>
                                </tr>
                                </thead>
                            </table>
                            <div class="tbl_wrap t_left dictionaryPopup">
                                <table class="tbl_style2" ref="mainDictionaryListFef">
                                    <colgroup>
                                        <col style="width: 35%;">
                                        <col style="width: 35%;">
                                        <col style="width: 30%;">
                                    </colgroup>
                                    <tbody v-if="searchList.length > 0">
                                        <tr v-for="(rowData, index) in searchList" 
                                            :key="index" 
                                            @click.stop="selectDictionary(rowData)" 
                                            class="border-bottom cursor-pointer"
                                            :class="selectDictionaryId == rowData.dictionaryId ? 'selected' : null">
                                            <td class="py-2 text-left" :title="rowData.similarTagName">
                                                <span class="ellipsis">{{`${rowData.similarTagName}`}}</span>
                                            </td>
                                            <td class="py-2 text-left" :title="rowData.representativeTagName">
                                                <span class="ellipsis">{{`* ${rowData.representativeTagName}`}}</span>
                                            </td>
                                            <td class="py-2 text-center">
<!--                                                <button class="sm_btn color_1" @click="selectDictionary(rowData)">사전선택</button>-->
                                                <button class="sm_btn" @click.stop="addSimilarTag(rowData)">유사어등록<span class="icon-arrow-right"></span></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <table class="tbl_style2">
                                <colgroup>
                                    <col style="width: 35%;">
                                    <col style="width: 35%;">
                                    <col style="width: 30%;">
                                </colgroup>
                                <tbody v-if="searchList.length == 0 && !loading">
                                <tr>
                                    <td colspan="3">
                                        <div class="nodata_txt"><p>결과를 찾을 수 없습니다.<br/>우측 신규등록 버튼을 눌러 등록해 주세요.</p></div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="layout_item" :style="{'width' : changeOnlyDisplayWord ? '100%' : '50%'}">
                          <div class="view_cont">
                            <ul class="column col_1" v-if="similarTagList.length > 0">
                              <li>
                                <div class="label_txt">
                                  <span>대표어</span>
                                  <button v-if="!changeOnlyDisplayWord" type="button" class="closeBtn dictionaryPopup" title="사전선택취소" @click="resetSelectDictionary"></button>
                                </div>
                                <div>
                                  {{ representativeTag?.tagName }}
                                </div>
                              </li>
                            </ul>
                            <ul class="column col_1" style="max-height: 315px; overflow-y: scroll">
                              <li>
                                <table class="tbl_style2" ref="detailDictionaryFef">
                                  <colgroup>
                                    <col style="width: 15%;">
                                    <col style="width: 20%;">
                                    <col>
                                  </colgroup>
                                  <thead>
                                  <tr>
                                    <th>선택</th>
                                    <th>분류</th>
                                    <th>명칭</th>
                                  </tr>
                                  </thead>
                                  <tbody v-if="similarTagList.length > 0">
                                  <tr v-for="(tag, i) in similarTagList"
                                      :key="i"
                                      @click="clickSimilarTagList(tag,$event)"
                                      class="border-bottom cursor-pointer"
                                      :class="checkedTag?.tagId == tag.tagId ? 'selected' : null"
                                  >
                                    <td class="py-1 text-center border-right" @click.stop="">
                                      <input type="radio"
                                             :value="tag"
                                             v-model="checkedTag"
                                             @change="handleSelectionChange"
                                      >
                                    </td>
                                    <td class="py-1 text-center border-right">
                                      {{ tag.representativeTagId == tag.tagId ? "대표어" : "유사어" }}
                                    </td>
                                    <td class="py-1 text-center">
                                      {{ tag.tagName }}
                                    </td>
                                  </tr>
                                  </tbody>
                                  <tbody v-else>
                                  <tr>
                                    <td colspan="3">
                                      <div class="nodata_txt">
                                        <p>사전을 선택해주세요.
                                        </p>
                                      </div>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                              </li>
                            </ul>
                            <ul class="column col_1" v-if="similarTagList.length > 0">
                              <li>
                                <div style="width: 100%;display: inline-block;">
                                  <button v-if="(user.admin || user.committee) && !changeOnlyDisplayWord" type="button" class="dictionary_btn" style="float: left; background-color: palevioletred" @click="deleteDictionary">사전삭제</button>
                                  <button v-if="crntObj.isSearchOption" type="button" class="dictionary_btn" style="float: right;"  @click="callSearchTagOption">적용하기</button>
                                  <button v-else type="button" class="dictionary_btn" style="float: right;" @click="callModifyTagFunction">적용하기</button>
                                  <button type="button" class="dictionary_btn" @click="saveDictionary">사전저장</button>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Loading :visible="loading"></Loading>
    </div>
</template>
<script>
    
    import Loading from '@common/loading'
    import {createNamespacedHelpers} from "vuex";
    const Hub = createNamespacedHelpers('Hub');
    import { v4 } from "uuid";
    function initialState () {
        return {
            isDragging: false,
            offsetX: 30,
            offsetY: 50,
            positionX: 53,
            positionY: 53,
            loading: false,

            openBln: false,
            processId: null,
            category: null,
            key: null,
            tagId: null,
            changeOnlyDisplayWord: false,

            categoryToKoreaLang: {
                PROCESS: "공정",
                MATERIAL: "재료",
                EQUIPMENT: "측정/분석",
            },
            searchList: [],
            query: "",
            similarTagList : [],
            addTagList : [],
            selectDictionaryId : null,
            refreshKey : 0,
            checkedTag : null,
            
            searchInputTimer: null,
            searchInputDelay: 400,
        }
    }
    
    export default {
        components: {
            Loading,
        },
        props: {
            crntObj: Object,
            checkedTagDictionaryId: {
                type: Number,
                default() {
                    return null;
                }
            }
        },
        watch: {
            crntObj: {
                deep : true , 
                async handler () {
                    if(this.openBln === true){
                        await this.resetData();
                        this.crntObj.closeHandler();
                        return;
                    }
                    if(this.key != null && this.key != this.crntObj.key){
                        await this.resetData();
                        this.crntObj.closeHandler();
                        return;
                    }
                    await this.resetData();
                    await this.setData();
                    await this.search();
                    if(this.changeOnlyDisplayWord){
                        const response = await this.$wApi.dictionary.getDictionaryKeyLinkByProcessIdAndKey({
                          key: this.key
                          , processId: this.processId
                        });
                        this.selectDictionary(response);
                    }
                    this.refreshKey++
                }
            },
            refreshKey: {
              async handler() {
                if (this.selectDictionaryId != null && this.selectDictionaryId != 0) {
                  try {
                    this.loading = true;
                    this.checkedTag = null;
                    return this.similarTagList = await this.$wApi.dictionary.detailDictionary({dictionaryId: this.selectDictionaryId});
                  } catch (e) {
                    console.log(e);
                  } finally {
                    this.loading = false;
                  }
                }
              }
            },
            similarTagList: {
                async handler() {
                    this.$nextTick(function () {
                        if (this.query.replace(/[-_\s+]/gi, "").toUpperCase() != "") {
                            for (let similarTagListIndex = 0; similarTagListIndex < this.similarTagList.length; similarTagListIndex++) {
                                let similarTag = this.similarTagList[similarTagListIndex];
                                if (similarTag.tagName.replace(/[-_\s+]/gi, "").toUpperCase() == this.query.replace(/[-_\s+]/gi, "").toUpperCase()) {
                                    this.checkedTag = similarTag;
                                    break;
                                }
                            }
                        } else {
                            if (this.similarTagList.length > 0) {
                                this.checkedTag = this.similarTagList[0];
                            }
                        }
                    });
                }
            },
        },
        computed: {
          representativeTag(){
            //console.log("this.similarTagList",this.similarTagList)
            if(this.similarTagList != null && this.similarTagList.length > 0){
              return this.similarTagList.filter(item => item.representativeTagId == item.tagId)[0];
            }
          }
        },
        mounted() {

        },
        data() {
            return initialState();
        },
        methods: {
            ...Hub.mapMutations(
                [
                  "setEditAttributePopFlag",
                ]
            ),
            clickCloseHandler(e) {
                e.preventDefault();
                this.crntObj.closeHandler();
            },
            startDragging(event) {
                return;
                this.isDragging = true;
                this.offsetX = event.clientX - event.currentTarget.getBoundingClientRect().left;
                this.offsetY = event.clientY - event.currentTarget.getBoundingClientRect().top;
            },
            dragElement(event) {
                return;
                if (this.isDragging) {
                    this.positionX = event.clientX - this.offsetX;
                    this.positionY = event.clientY - this.offsetY;
                }
            },
            stopDragging() {
                this.isDragging = false;
            },
            preventDrag(event) {
                event.stopPropagation();
            },
            async saveDictionary(){
              if(this.similarTagList == null || this.similarTagList.length == 0){
                alert("사전을 선택해주세요.");
                return;
              }
              const confirmResult = await confirm("해당 사전을 저장하시겠습니까?");
              if(confirmResult){
                try {
                  this.loading = true;
                  const res = await this.$wApi.dictionary.editDictionary({
                    dictionaryId: this.selectDictionaryId,
                    tagIdList : this.addTagList
                  }) ;
                  if(!res.error){
                    window.alert("저장되었습니다.");
                    this.addTagList = [];
                    this.refreshKey++;
                  }
                }catch (e){
                  console.log(e)
                }finally {
                  this.loading = false;
                }
              }

            },
            async deleteDictionary(){
              const confirmResult = await confirm("해당 사전을 삭제하시겠습니까?");
              if(!confirmResult)return;
              try {
                 const res = await this.$wApi.dictionary.deleteDictionary({
                  dictionaryId: this.selectDictionaryId,
                 });
                 if(!res.error){
                   alert("해당 사전이 비공개 처리되었습니다.");
                   await this.search();
                   this.resetSelectDictionary()
                 }else{
                   alert(`${res.message}`);
                 }
              }catch (e){
                console.log(e);
              }
            },
            async setData(){
                for await (const item of Object.entries(this.crntObj)) {
                    if(typeof item[1] != "function"){
                        this[item[0]] = item[1]    
                    }
                }
            },
            async resetData(){
                for await (const item of Object.entries(initialState())) {
                    if(typeof item[1] != "function"){
                        this[item[0]] = item[1]    
                    }
                }
            },
            changeQuery(event){
                this.query = event.target.value;
                if(this.searchInputTimer){
                    clearTimeout(this.searchInputTimer);
                    this.searchInputTimer = setTimeout(async () => { await this.search(); }, this.searchInputDelay);
                }else{
                    this.searchInputTimer = setTimeout(async () => { await this.search(); }, this.searchInputDelay);
                }
                
            },
            inputEnter(event){
                if(event.code === 'Enter' || event.keyCode === 13) {
                    this.search();
                }
            },
            async clickFirstRow() {
                this.$nextTick(function () {
                    if(this.searchList.length > 0) {
                        this.$refs["mainDictionaryListFef"].querySelector("tbody tr").click();
                    }
                });
            },
            async search(){
                try{
                    this.loading = true;
                    this.searchList = await this.$wApi.dictionary.getAll({tagType : this.category, query: this.query});

                    if (this.query != "" && this.query != null) {
                        // 최초 진입 또는 검색어가 없을때는 제외, 선택된 사전이 있는 경우는 제외
                        if (this.selectDictionaryId == null) {
                            await this.clickFirstRow();
                        } else { // 선택된 사전이 있고, 검색중인 정보가 있을때
                            for (let similarTagListIndex = 0; similarTagListIndex < this.similarTagList.length; similarTagListIndex++) {
                                let similarTag = this.similarTagList[similarTagListIndex];
                                if (similarTag.tagName.replace(/[-_\s+]/gi, "").toUpperCase() == this.query.replace(/[-_\s+]/gi, "").toUpperCase()) {
                                    this.checkedTag = similarTag;
                                    break;
                                }
                            }
                        }
                    }
                }catch (e) {
                    this.loading = false;
                    window.alert("조회중 오류 발생");
                }finally {
                    this.loading = false;
                }
            },
            selectDictionary(rowData) {
              this.addTagList = [];
              this.selectDictionaryId = rowData.dictionaryId;
              this.refreshKey++
            },
            async addSimilarTag(rowData) {
              if(this.similarTagList == null || this.similarTagList.length == 0){
                alert("유사어를 추가할 사전을 선택해주세요.");
                return;
              }

              if(this.similarTagList.filter(item => item.tagId == rowData.similarTagId).length > 0){
                alert("이미 추가된 유사어입니다.");
                return;
              }
              this.loading = true;
              let checkDictionary = await this.$wApi.dictionary.tag.get(null, rowData.similarTagId);
              this.loading = false;
              let confirm = true;
              if(checkDictionary.similarTagList.length > 1){
                  confirm = await window.confirm("다른 사전에서 대표어로<br>사용 중인 이름입니다.<br><br>추가하시겠습니까?");
              }
              if(!confirm){
                  return;
              }

              this.addTagList.push(rowData.similarTagId)

              this.similarTagList.push({
                dictionaryId : rowData.dictionaryId,
                tagId : rowData.similarTagId,
                tagName : rowData.similarTagName,
              })
              this.loading = false;
              alert("추가되었습니다.");
            },
            async createDictionary() {
              // 조회 불가능한 데이터 중 해당 데이터가 있는지 먼저 확인하여 있다면 해당 값만 update
              if(this.query == null || this.query == ''){
                return;
              }
              const confirmResult = await window.confirm(`"${this.query}"를 신규등록 하시겠습니까?`);
              if(!confirmResult) return;
              try {
                this.loading = true;
                const response = await this.$wApi.dictionary.createDictionary({tagType: this.category, tagName: this.query});
                if(!response.error){
                  window.alert("단어를 등록했습니다.");
                  await this.search();
                }else{
                  window.alert(response.message);
                  return;
                }
              } catch (e) {
                console.log(e);
              } finally {
                this.loading = false;
              }
            },
            handleSelectionChange() {
              console.log('Selected Object:', this.checkedTag);
              // 선택한 객체에 대한 추가적인 로직을 수행
            },
            async callModifyTagFunction(event) {
                if (this.checkedTag == null) {
                    window.alert("표시어로 사용할 태그를 선택해 주세요.");
                    return;
                }
                if (this.addTagList.length > 0) {
                    let saveConfirm = await window.confirm("수정 중이던 사전 정보를 저장하시겠습니까?");
                    if(saveConfirm){
                        await this.saveDictionary();
                        return;
                    }else{
                        return;
                    }
                }
                try{
                    let checkConfirm = await this.callConfirmFunc();
                    if(!checkConfirm){
                        return;
                    }
                    this.loading = true;
                    let newKey = null;
                    if(this.changeOnlyDisplayWord){
                        newKey = this.key;
                    }else{
                        newKey = v4();    
                    }
                    const requestData = {
                                            id: this.checkedTag.tagId
                                            , name: this.checkedTag.tagName
                                            , tagType: this.checkedTag.tagType
                                            , tagShape: null
                                            , newKey : newKey
                                        };
                    const key = await this.$props.crntObj.changeTagFunc(requestData);
                    
                    if(key != null) {
                      this.key = key;
                    }else{
                      this.key = newKey;
                    }
                    
                    if(this.key != null) {
                        // key link table insert or update
                        const keyLinkInsertOrUpdate = await this.$wApi.dictionary.changeLinkKey({
                            processId: this.processId
                            , key: this.key
                            , dictionaryId: this.checkedTag.dictionaryId
                            , tagId : this.checkedTag.tagId
                        });

                        if (keyLinkInsertOrUpdate.error) {
                            throw new Error("key link table insert or update error");
                        }
                    }
                    
                    this.loading = false;
                    if(this.key != null) {
                        this.$emit('update:checkedTagDictionaryId', null);
                        if(key != null) {
                            window.alert("생성이 완료되었습니다.");
                        }else{
                            window.alert("변경이 완료되었습니다.");    
                        }
                        this.clickCloseHandler(event);
                    }else{
                        this.$emit('update:checkedTagDictionaryId', this.checkedTag.dictionaryId);
                        await window.alert("표시어를 원하는 위치에 놓아주세요.");
                        this.clickCloseHandler(event);
                        document.querySelector("#tagElemClone").click();
                    }
                }catch (e) {
                    this.loading = false;
                    window.alert("표시어 변경중 오류가 발생했습니다.")
                }finally {
                    this.loading = false;
                }
            },
            async callSearchTagOption(event) {
              if (this.checkedTag == null) {
                window.alert("표시어로 사용할 정보를 선택해 주세요.");
                return;
              }
              if (this.addTagList.length > 0) {
                  let saveConfirm = await window.confirm("수정 중이던 사전 정보를 저장하시겠습니까?");
                  if (saveConfirm) {
                      await this.saveDictionary();
                      return;
                  } else {
                      return;
                  }
              }

              let checkConfirm = await this.callConfirmFunc();
              if (!checkConfirm) {
                  return;
              }

              this.$props.crntObj.changeTagFunc({
                dictionaryId: this.selectDictionaryId
                , tagName: this.checkedTag.tagName
                , category: this.checkedTag.tagType.toUpperCase()
              });

              this.clickCloseHandler(event);
            },
            async clickSimilarTagList(tag, event){
                this.checkedTag = tag;
                if(this.$props.crntObj.isSearchOption){
                    await this.callSearchTagOption(event);       
                }else{
                    await this.callModifyTagFunction(event);       
                }
            },
            async callConfirmFunc(){
                let resultFlag = true;
                const cookieName = "selectTagPopup";
                let cookieCheck = this.getCookie(cookieName);
                if(cookieCheck){
                    return resultFlag;
                }
                const msg = "선택된 표시어를 적용하시겠습니까?";
                const html = `<div>일주일간 보지 않기 
                                <input  type="checkbox" 
                                        onChange="if(event.target.checked){let todayDate = new Date(); todayDate.setDate(todayDate.getDate() + 7); window.document.cookie = 'selectTagPopup='+escape(event.target.checked)+'; path=/; expires='+todayDate.toUTCString()}" />
                              </div>`;
                const option = {
                    
                };
                resultFlag = await window.confirm(msg, html, option);
                if(!resultFlag){ // cookie 날려주기
                    this.deleteCookie(cookieName);
                }
                return resultFlag;
            },
            getCookie(name) {
                let value = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
                return value ? value[2] : null;
            },
            deleteCookie(name) {
                window.document.cookie = escape(name)+"=; path=/; expires=Thu, 01 Jan 1999 00:00:10 GMT;";
            },
            resetSelectDictionary(){
                this.addTagList = [];
                this.similarTagList = [];
                this.selectDictionaryId = null;
                this.refreshKey++;
            },
            async appendSimilarTag() {
                if (this.similarTagList.length <= 0 || this.similarTagList == null) {
                    window.alert("유사어를 추가할 사전을 선택해 주세요.");
                    return;
                }

                if (this.query.trim().length == 0) {
                    window.alert("추가할 유사어를 입력해 주세요.");
                    return;
                }

                if (this.similarTagList.filter(item => item.tagName.trim().toUpperCase() == this.query.trim().toUpperCase()).length > 0) {
                    window.alert("이미 존재하는 유사어입니다.");
                    return;
                }
                try {
                    this.loading = true;
                    const response = await this.$wApi.dictionary.getDictionaryByRepresentativeName({
                        tagType: this.category,
                        query: this.query,
                    });
                    this.loading = false;
                    if (!response.error) {
                        let rowData = {
                            dictionaryId : response.id
                            , similarTagId : response.tagId
                            , similarTagName : response.representativeTagName
                        };
                        await this.addSimilarTag(rowData);
                    } else {
                        window.alert("유사어 등록중 오류가 발생했습니다.");
                        return;
                    }
                } catch (e) {
                    console.log(e);
                } finally {
                    this.loading = false;
                }
            },
        }
    }
</script>
<style lang="scss">
  .dictionary_btn{
      display: inline-block;
      float: right;
      width: 100px;
      height: 48px;
      margin: 3px;
      padding: 0px 10px;
      border-radius: 6px;
      color: #fff;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      background: #447199;
      line-height: 48px;
      cursor: pointer;
  }
</style>